import React, { useState, useEffect, useRef } from "react";
import DatetimeRangePicker from "react-datetime-range-picker";
import Datetime from "react-datetime";
import ReactSlider from "react-slider";
import ToggleSwitch from "./ToggleSwitch";

const placehold = { placeholder: "Choose Date" };

export const FormWrapLabel = (props) => (
  <div className="form-group">
    <label htmlFor={props.FilterName}>{props.FilterLabel}</label>
    {props.children}
    <small id={props.FilterName + "Help"} className="form-text text-muted">
      {props.FilterDesc}
    </small>
  </div>
);

export const TextFilter = (props) => {
  const [Value, setValue] = useState(props.value);
  const [isChanged, setIsChanged] = useState(false);
  const handleChange = (e) => {
    setIsChanged(true);
    setValue(e.target.value);
  };
  const handleBlur = () => {
    if (isChanged) props.onChange(props.FilterName, Value);
  };
  return (
    <FormWrapLabel {...props}>
      <input
        type="text"
        className="form-control shadow-sm"
        name={props.FilterName}
        id={props.FilterName}
        // defaultValue={props.DefaultValue}
        onChange={handleChange}
        onBlur={handleBlur}
        value={Value}
      />
    </FormWrapLabel>
  );
};

export const AutoSuggest = (props) => (
  <FormWrapLabel {...props}>
    <select
      name={props.FilterName}
      id={props.FilterName}
      className="form-control"
      onChange={(e) => props.onChange(props.FilterName, e.target.value)}
      value={
        props.AutoValues.find((f) => f.isSelected)
          ? props.AutoValues.find((f) => f.isSelected).Value
          : 0
      }
    >
      <option value="0">Select</option>
      {props.AutoValues.map((opt, key) => {
        return (
          <option value={opt.Value} key={key}>
            {opt.Label}
          </option>
        );
      })}
    </select>
  </FormWrapLabel>
);

export const BooleanField = (props) => {
  const { onChange, FilterName, Value } = {
    onChange: () => {
      // This is intentional
    },
    ...props,
  };

  return (
    <FormWrapLabel {...props}>
      <div className="float-right">
        <ToggleSwitch
          id={FilterName}
          currentValue={Value}
          Text={["Yes", "No"]}
          Small={true}
          onChange={(event) => onChange(FilterName, event.target.checked)}
        />
      </div>
    </FormWrapLabel>
  );
};

export const RangeSlider = (props) => (
  <FormWrapLabel {...props}>
    {props.IsRange ? (
      <ReactSlider
        className="horizontal-slider"
        thumbClassName="slider-thumb"
        trackClassName="slider-track"
        min={props.Min}
        max={props.Max}
        defaultValue={[props.FieldMin, props.FieldMax]}
        ariaLabel={["Lower thumb", "Upper thumb"]}
        ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
        renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
        pearling
        minDistance={1}
        onChange={(e) => props.onChange(props.FilterName, e)}
      />
    ) : (
      <ReactSlider
        className="horizontal-slider"
        thumbClassName="slider-thumb"
        trackClassName="slider-track"
        min={props.FieldMin}
        max={props.FieldMax}
        defaultValue={props.Min}
        ariaLabel={["Lower thumb", "Upper thumb"]}
        ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
        renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
        pearling
        minDistance={1}
        onChange={(e) => props.onChange(props.FilterName, e)}
      />
    )}
  </FormWrapLabel>
);

export const RangeInput = (props) => {
  const [minimum, setMin] = useState(props.Min);
  const [maximum, setMax] = useState(props.Max);
  const [lastChanged, setLastChanged] = useState(null);
  const useDidMountEffect = (func, deps) => {
    const didMount = useRef(false);

    useEffect(() => {
      if (didMount.current) func();
      else didMount.current = true;
    }, deps);
  };

  const handleChangeMin = (event) => {
    setMin(event.target.value);
    setLastChanged("Min");
  };
  const handleChangeMax = (event) => {
    setMax(event.target.value);
    setLastChanged("Max");
  };
  useDidMountEffect(() => {
    props.onChange(props.FilterName, [minimum, maximum, lastChanged]);
  }, [minimum, maximum]);

  return (
    <FormWrapLabel {...props}>
      <div className="o5-numberfilter">
        <div>
          <label for="Minimum">Minimum</label>
          <input
            name="Minimum"
            type="number"
            className="form-control shadow-sm"
            id="Minimum"
            aria-describedby="Minimum"
            // defaultValue={props.DefaultValue}
            placeholder={props.FieldMin}
            value={minimum}
            autoFocus={props.LastChanged === "Min" ? true : false}
            onChange={handleChangeMin}
            min={props.FieldMin}
            max={props.FieldMax}
          />
        </div>
        <div>
          <label for="Maximum">Maximum</label>
          <input
            name="Maximum"
            id="Maximum"
            type="number"
            aria-describedby="Maximum"
            className="form-control shadow-sm"
            // defaultValue={props.DefaultValue}
            value={maximum}
            placeholder={props.FieldMax}
            autoFocus={props.LastChanged === "Max" ? true : false}
            onChange={handleChangeMax}
            min={props.FieldMin}
            max={props.FieldMax}
          />
        </div>
      </div>
    </FormWrapLabel>
  );
};

export const DateTimeRange = (props) => (
  <FormWrapLabel {...props}>
    <DatetimeRangePicker
      dateFormat="ll"
      className="range-filter"
      locale={props._.MomentLang}
    />
  </FormWrapLabel>
);

export const TimeRange = (props) => (
  <FormWrapLabel {...props}>
    <DatetimeRangePicker
      dateFormat={false}
      className="range-filter"
      locale={props._.MomentLang}
    />
  </FormWrapLabel>
);

export const DateRange = (props) => (
  <FormWrapLabel {...props}>
    <DatetimeRangePicker
      onChange={(e) => props.onChange(props.FilterName, e)}
      dateFormat="ll"
      timeFormat={false}
      startDate={props.Min}
      endDate={props.Max}
      inputProps={placehold}
      closeOnSelect={true}
      className="range-filter"
      locale={props._.MomentLang}
    />
  </FormWrapLabel>
);

export const DateTime = (props) => (
  <FormWrapLabel {...props}>
    <Datetime
      onChange={(e) => props.onChange(props.FilterName, e)}
      dateFormat="ll"
      locale={props._.MomentLang}
    />
  </FormWrapLabel>
);

export const Time = (props) => (
  <FormWrapLabel {...props}>
    <Datetime dateFormat={false} locale={props._.MomentLang} />
  </FormWrapLabel>
);

export const Date = (props) => (
  <FormWrapLabel {...props}>
    <Datetime
      onChange={(e) => {
        var day = e._d.getDate();
        var month = e._d.getMonth() + 1;
        var year = e._d.getFullYear();
        props.onChange(props.FilterName, `${month}-${day}-${year}`);
      }}
      value={props.value}
      timeFormat={false}
      locale={props._.MomentLang}
    />
  </FormWrapLabel>
);
